module.exports = __webpack_public_path__ + "static/img/1.ea4ad1b2.jpg";